module.exports = __webpack_public_path__ + "img/android_app.cfe7e8c9.svg";